import React, { Component } from 'react';
import { authentication } from '../../services/Authentication';
import { config } from './Constants';
import helpers from '../../Function';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import momentbusiness from 'moment-business-time';
//import business from 'moment-business-days';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery"
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import HeaderTab from "./Header";

class NewForm extends Component {

    constructor(props) {
        super(props);

        const { name, user_id, jwt } = authentication.currentUserValue;

        const search = window.location.search;
        const params = new URLSearchParams(search);
        const parame_id = params.get('id');
        const parame_phone = params.get('phone');
        const parame_title = params.get('title');

        this.state = {
            jwt: jwt,
            project_home: [],
            service_category: [],
            emailto: [],
            emailcc: [],
            service_type: [{ value: '', display: 'เลือกเรื่องย่อย', department: [], emailto: [], emailcc: [], sla: 0 }],
            group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }],
            service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }],
            modalIsOpen: false,
            modalIsOpenCancel: false,
            get_id: parame_id,
            get_phone: (parame_phone != 'null' ? parame_phone : ''),
            first_name: '',
            last_name: '',
            owner_first_name: '',
            owner_last_name: '',
            phone_come: '',
            phone_contact: '',
            project_name: '',
            home_number: '',
            project_status: '',
            warranty: '',
            category: (parame_title == 1 && "5e232c684d59a834545e911b" || parame_title == 2 && "5e232c9a4d59a834545e911c" || parame_title == 3 && "5e232cae4d59a834545e911d"),
            title: '',
            grouptypeid: '',
            detail: '',
            contact: 'cc',
            delivery_date: '',
            expire_date: '',
            service_status: 'progress',
            create_by: name,
            create_by_id: user_id,
            project_id: '',
            express: false,
            sla_start_date: '',
            sla_end_date: '',
            sla_start_time: '',
            sla_end_time: '',
            sla_val: '',
            fromList: [],
            detail1: '',
            detail2: '',
            detail3: '',
            detail4: '',
            detail5: '',
            detail6: '',
            detail7: '',
            detail8: '',
            detail9: '',
            detail10: '',
            subscriber1: '',
            subscriber2: '',
            subscriber3: '',
            subscriber4: '',
            subscriber5: '',
            subscriber6: '',
            subscriber7: '',
            subscriber8: '',
            subscriber9: '',
            subscriber10: '',
            operator1: '',
            operator2: '',
            operator3: '',
            operator4: '',
            operator5: '',
            operator6: '',
            operator7: '',
            operator8: '',
            operator9: '',
            operator10: '',
            note1: '',
            note2: '',
            note3: '',
            note4: '',
            note5: '',
            note6: '',
            note7: '',
            note8: '',
            note9: '',
            note10: '',
            serviceStatus1: '',
            serviceStatus2: '',
            serviceStatus3: '',
            serviceStatus4: '',
            serviceStatus5: '',
            serviceStatus6: '',
            serviceStatus7: '',
            serviceStatus8: '',
            serviceStatus9: '',
            serviceStatus10: '',
            serviceDate1: '',
            serviceDate2: '',
            serviceDate3: '',
            serviceDate4: '',
            serviceDate5: '',
            serviceDate6: '',
            serviceDate7: '',
            serviceDate8: '',
            serviceDate9: '',
            serviceDate10: '',
            successDate1: '',
            successDate2: '',
            successDate3: '',
            successDate4: '',
            successDate5: '',
            successDate6: '',
            successDate7: '',
            successDate8: '',
            successDate9: '',
            successDate10: '',
            editDate1: '',
            editDate2: '',
            editDate3: '',
            editDate4: '',
            editDate5: '',
            editDate6: '',
            editDate7: '',
            editDate8: '',
            editDate9: '',
            editDate10: '',
            residences: [],
            IsCallCenter: false,
            IsMore: false,
            owner_id: "",
            service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }],
            matches: window.matchMedia("(min-width: 768px)").matches
        }

        for (var i = 1; i <= 10; i++) {
            this.state.fromList.push({
                row: i
                , col1: "detail" + i
                , col2: "subscriber" + i
                , col3: "operator" + i
                , col4: "serviceDate" + i
                , col5: "successDate" + i
                , col6: "editDate" + i
                , col7: "note" + i
                , col8: "serviceStatus" + i
                , col9: "service_type_id" + i
                , col10: "service_type_name" + i
                ,
            });
        }

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.change = this.change.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);


        this.cancelForm = this.cancelForm.bind(this);
        this.closeModalCancel = this.closeModalCancel.bind(this);
        this.openModalCancel = this.openModalCancel.bind(this);

        helpers.checklogin(this.state.jwt);

        moment.locale('en', {
            workinghours: {
                0: null,
                1: ['00:00:00', '23:59:59'],
                2: ['00:00:00', '23:59:59'],
                3: ['00:00:00', '23:59:59'],
                4: ['00:00:00', '23:59:59'],
                5: ['00:00:00', '23:59:59'],
                6: null
            }
        });

    }

    changeExpireDate = date => {
        this.setState({
            expire_date: date
        });
    }

    changeSLAStartDate = date => {
        this.setState({
            sla_start_date: date
        });
    }

    changeSLAEndDate = date => {
        this.setState({
            sla_end_date: date
        });
    }

    async change(e) {
        try {
            this.setState({
                [e.target.name]: e.target.value,
            });
    
            if (e.target.name == "category") {
                console.log(`category selected`)
                $("#detail_list").hide();
                var categoryId = e.target.value
                this.setState({
                    group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }]
                });
                // ถ้าไม่เท่ากับแจ้งซ่อม  &&ห้ามแตะ
                if (categoryId != "5e232c684d59a834545e911b") {
                    $("#detail_list").hide();
                }
    
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
    
                const serviceGroupData = await(await fetch(config.url.API_URL + '/service_groups/?categoryid=' + categoryId + '&sortnameth=1&activestatus=1', requestOptions)).json()
                
                if (Array.isArray(serviceGroupData.data) && serviceGroupData.data.length > 0) {
                    let FromApi = serviceGroupData.data.map(datas => {
                        return { value: datas.id, display: datas.name_th }
                    });
        
                    this.setState({
                        group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }].concat(FromApi),
                        service_type: [{ value: '', display: 'เลือกเรื่องย่อย', department: [], emailto: [], emailcc: [], sla: 0 }],
                        IsCallCenter: true
                    });
    
                    
                }else{
                    const juristicGroupData = await(await fetch(config.url.API_URL + '/juristic_groups/?categoryid=' + categoryId + '&sortnameth=1&activestatus=1', requestOptions)).json()
                    if (juristicGroupData.data != undefined) {
                        let FromApi = juristicGroupData.data.map(datas => {
                            return { value: datas.id, display: datas.name_th }
                        });
                        console.log(`from jur api`)
                        console.log(FromApi)
                        this.setState({
                            group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }].concat(FromApi),
                            service_type: [{ value: '', display: 'เลือกเรื่องย่อย', department: [], emailto: [], emailcc: [], sla: 0 }],
                            IsCallCenter: false
                        });
                    }
                }
    
                const serviceTypeData = await(await fetch(config.url.API_URL + '/service_types/?categoryid='+ this.state.category + '&sortnameth=1&activestatus=1', requestOptions)).json()
                if (Array.isArray(serviceTypeData.data) && serviceTypeData.data.length > 0) {
                    let FromApi = serviceTypeData.data.map(datas => {
                        return { value: `${datas.id},${datas.name_th}`, display: datas.name_th, emailto: datas.emailto, emailcc: datas.emailcc, sla: datas.sla, multi: datas.multi }
                    });
    
                    this.setState({
                        service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                    });
                } else {
    
                    const serviceTypeData = await(await fetch(config.url.API_URL + '/juristic_types/?main_id='+ this.state.category + '&sortnameth=1&activestatus=1', requestOptions)).json()
                    if(serviceTypeData.data && serviceTypeData.data.length > 0) {
                        let FromApi = serviceTypeData.data.map(datas => {
                            return { value: datas._id, display: datas.name_th, emailto: datas.emailto_y, emailcc: datas.emailcc_y, sla: datas.sla, multi: datas.multi }
                        });
    
                        this.setState({
                            service_type_all: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                        });
                    }
                }
    
            } else if (e.target.name == "grouptypeid") {
                $("#detail_list").hide();
                var group_id = e.target.value
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
    
                const serviceTypeData = await(await fetch(config.url.API_URL + '/service_types/?categoryid='+ this.state.category + '&servicegroupid=' + group_id + '&sortnameth=1&activestatus=1', requestOptions)).json()
                if (Array.isArray(serviceTypeData.data) && serviceTypeData.data.length > 0) {
                    console.log(`service type > 1`)
                    let FromApi = serviceTypeData.data.map(datas => {
                        return { value: datas.id, display: datas.name_th, emailto: datas.emailto, emailcc: datas.emailcc, sla: datas.sla, multi: datas.multi }
                    });
                    
                    this.setState({
                        service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                    });
                }else{
                    console.log(`jur type > 1`)
                    const juristicTypeData = await(await fetch(config.url.API_URL + '/juristic_types/?main_id=' + this.state.category + '&juristic_category=' + group_id + '&sortnameth=1&activestatus=1', requestOptions)).json()
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    if (Array.isArray(juristicTypeData.data) && juristicTypeData.data.length > 0) {
                        let FromApi = juristicTypeData.data.map(datas => {
                            return { value: datas._id, display: datas.name_th, emailto: datas.emailto_y, emailcc: datas.emailcc_y, sla: datas.sla, multi: datas.multi }
                        });

                        this.setState({
                            service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                        });
                    }
                }
    
                this.setState({
                    emailto: [],
                    emailcc: []
                });
            } else if (e.target.name == "title") {
    
                //console.log(this.state.category)
                // if ((e.target.value == "5e2feeced5fbcf576287f461" || this.state.category == "5e232c684d59a834545e911b") || (e.target.value == "5ed7ad78e89147747e46a78a" || this.state.category == "5ed7adcbe89147747e46a78b")) {
                //     this.setState({ IsMore: true });
                //     $("#detail_list").show();
                // } else {
                //     this.setState({ IsMore: false });
                //     $("#detail_list").hide();
                // }
    
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
    
                //email to
                const resultto = this.state.service_type.find(({ value }) => value === e.target.value);
                var idset = ""
                console.log("===============" + JSON.stringify(resultto));
    
                if (resultto.multi == 1) {
                    this.setState({ IsMore: true });
                    $("#detail_list").show();
                } else {
                    this.setState({ IsMore: false });
                    $("#detail_list").hide();
                }
    
                if (Array.isArray(resultto.emailto) && resultto.emailto.length) {
                    resultto.emailto.map(datas => {
                        if (idset == "") {
                            idset = "idset[]=" + datas;
                        } else {
                            idset += "&idset[]=" + datas;
                        }
                    });
    
    
                    const usersData = await (await fetch(config.url.API_URL + '/users/?' + idset, requestOptions)).json()
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);
                        let FromApi = usersData.data.map(datas => {
                            return { value: datas.id, email: datas.email, display: datas.first_name + ' ' + datas.last_name }
                        });
                        console.log("========*/*/*/*/*/=======" + JSON.stringify(FromApi));
                        this.setState({
                            emailto: [].concat(FromApi)
                        });
                } else {
                    this.setState({ emailto: [] });
                }
                //END email to
    
                //email cc
                const resultcc = this.state.service_type.find(({ value }) => value === e.target.value);
                var idset = ""
                console.log(JSON.stringify(resultcc));
                if (Array.isArray(resultcc.emailcc) && resultcc.emailcc.length) {
                    resultcc.emailcc.map(datas => {
    
                        if (idset == "") {
                            idset = "idset[]=" + datas;
                        } else {
                            idset += "&idset[]=" + datas;
                        }
    
                    });
    
                    const userEmailData = await (await fetch(config.url.API_URL + '/users/?' + idset, requestOptions)).json()
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let FromApi = userEmailData.data.map(datas => {
                        return { value: datas.id, email: datas.email, display: datas.first_name + ' ' + datas.last_name }
                    });
                    this.setState({
                        emailcc: [].concat(FromApi)
                    });
                       
                } else {
                    this.setState({ emailcc: [] });
                }
                //END email cc
                //sla
                const resultsla = this.state.service_type.find(({ value }) => value === e.target.value);
                console.log("========resultsla=======" + JSON.stringify(resultsla));
                //alert(resultsla.sla);
                var startsla = new Date();
                var endsla = new Date();
    
                if (resultsla.sla > 24) {
                    //เกิน 1 วันให้นับวันถัดไป
                    endsla = new Date(moment(new Date()).add(((resultsla.sla) / 24), 'days'));
                    //endsla = new Date(business(new Date()).businessAdd((resultsla.sla+24))._h);
                    //endsla = new Date(moment(new Date()).addWorkingTime(((resultsla.sla + 24) / 24), 'days'));
                } else {
                    endsla = new Date(moment(new Date()).add(resultsla.sla, 'hours'));
                    //endsla = new Date(moment(new Date()).addWorkingTime((resultsla.sla), 'hours'));
                }
                this.setState({
                    sla_start_date: startsla,
                    sla_end_date: endsla,
                    sla_start_time: moment(startsla).format('HH:mm'),
                    sla_end_time: moment(endsla).format('HH:mm'),
                    sla_val: resultsla.sla
                });
    
            } else if (e.target.name == "project_name") {
                $("#detail_list").hide();
                this.setState({
                    emailto: [],
                    emailcc: [],
                    sla_start_date: "",
                    sla_end_date: "",
                    sla_start_time: "",
                    sla_end_time: "",
                    sla_val: "",
                    [e.target.name]: e.target.value,
                });
    
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
    
                const projectHomeData = await(await fetch(config.url.API_URL + '/project_homes/' + e.target.value, requestOptions)).json()
                let project_homes = projectHomeData.data

                const residenceData = await (await fetch(config.url.API_URL + '/residences/?projecthomeid=' + project_homes.id, requestOptions)).json()

                           
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                let residenceFromApi = await residenceData.data.map(datas => {
                    return datas.house_no
                });

                this.setState({
                    residences: residenceFromApi
                });
    
                const sericeCategoryData = await (await fetch(config.url.API_URL + '/service_categorys/?activestatus=1', requestOptions)).json()
                                    
                var sericeCategoryFromApi = sericeCategoryData.data.filter(item => item.id != '5e232c684d59a834545e911b').map(datas => {
                    return { value: datas.id, display: datas.name_th }
                });
                console.log(`after filter`)
                console.log(sericeCategoryFromApi)
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                if (project_homes.central_flag != undefined) {
                    if (project_homes.central_flag == 1) {
                        const juristicCategoryFromAPI = await (await fetch(config.url.API_URL + '/juristic_categorys/?activestatus=1', requestOptions)).json()
                        
                        let juristicCategoryFromApi = juristicCategoryFromAPI.data.map(datas => {
                            return { value: datas._id, display: datas.name_th }
                        });

                        let juristicCategoryFromApiAll = sericeCategoryFromApi.concat(juristicCategoryFromApi)
                        this.setState({
                            service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(juristicCategoryFromApiAll),
                            service_type: [{ value: '', display: 'เลือกเรื่องย่อย', department: [], emailto: [], emailcc: [], sla: 0 }],
                            group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }],
                        });

                    } else {
                        this.setState({
                            service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(sericeCategoryFromApi),
                            service_type: [{ value: '', display: 'เลือกเรื่องย่อย', department: [], emailto: [], emailcc: [], sla: 0 }],
                            group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }],
                        });
                    }
                } else {
                    const serviceCategoryData = await (await fetch(config.url.API_URL + '/service_categorys/?activestatus=1', requestOptions)).json()
                     
                    const serviceCategoryFromApi = serviceCategoryData.data.map(datas => {
                        return { value: datas.id, display: datas.name_th }
                    });

                    this.setState({
                        service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(serviceCategoryFromApi),
                        service_type: [{ value: '', display: 'เลือกเรื่องย่อย', department: [], emailto: [], emailcc: [], sla: 0 }],
                        group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }],
                    });
                     
                }
            }
        } catch (error) {
            console.log(`err`)
            console.log(error)
        }
        

        //console.log("========2020-03-23T11:14:00.000Z======="+ moment(new Date("2020-03-23 11:23:00.000Z")).format('DD/MM/YYYY HH:mm'));
    }

    async componentDidMount() {
        const handler = e => this.setState({ matches: e.matches });
        window.matchMedia("(min-width: 768px)").addListener(handler);

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };
        /*
                if(this.state.category){
        
                    fetch(config.url.API_URL+'/service_types/?categoryid='+this.state.category+'&sortnameth=1', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);
                        let FromApi = data.data.map(datas => {
                            return {value: datas.id, display: datas.name_th}
                        });
                        this.setState({
                            service_type: [{value: '', display: 'เลือกเรื่องย่อย'}].concat(FromApi)
                        });
                    });
                }
        */
        const projectHomeData = await (await fetch(config.url.API_URL + '/project_homes', requestOptions)).json()
         
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        //alert(data.status);
        let projectHomeFromApi = projectHomeData.data.map(datas => {
            return { value: datas.id, display: datas.name_th }
        });
        this.setState({
            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(projectHomeFromApi)
        });
           

        // fetch(config.url.API_URL + '/service_categorys/?activestatus=1', requestOptions)
        //     .then(res => res.json())
        //     .then(data => {
        //         // store user details and jwt token in local storage to keep user logged in between page refreshes
        //         //alert(data.status);
        //         let FromApi = data.data.map(datas => {
        //             return { value: datas.id, display: datas.name_th }
        //         });
        //         this.setState({
        //             service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(FromApi)
        //         });
        //     });

        if (this.state.get_id) {
            const residenceData = await (await fetch(config.url.API_URL + '/residences/' + this.state.get_id, requestOptions)).json()
                    if (Array.isArray(residenceData.data)) {
                        var datas = residenceData.data[0];
                        var address = "";

                        if (datas.project_homes.length) {
                            //name_th = datas.project_homes[0].name_th;
                            address = (datas.project_homes[0].moo && "หมู่ " + datas.project_homes[0].moo)
                                + (datas.project_homes[0].soi && " ซอย " + datas.project_homes[0].soi)
                                + (datas.project_homes[0].road && " ถนน " + datas.project_homes[0].road)
                                + (datas.project_homes[0].sub_district && " ตำบล/แขวง " + datas.project_homes[0].sub_district)
                                + (datas.project_homes[0].district && " อำเภอ/เขต " + datas.project_homes[0].district)
                                + (datas.project_homes[0].province && " จังหวัด " + datas.project_homes[0].province);
                        }

                        var fullName = "";
                        var tell = "";
                        var member_id = "";
                        if (datas.customer.length) {
                            var customer = datas.customer[datas.customer.length - 1];

                            if (customer.customer_name == '') {
                                customer = datas.customer[0];
                            }

                            fullName = (customer.customer_name ? customer.customer_name : "");
                            tell = (customer.customer_tell.length ? customer.customer_tell[0].tell : "")
                            member_id = customer.customer_id
                        }

                        var dataFullName = fullName.split(" ");

                        var curdate = moment(new Date());

                        var expired_insurance, diffdate;
                        if (datas.expired_insurance) {
                            expired_insurance = moment(datas.expired_insurance);
                            diffdate = curdate.diff(expired_insurance, 'days');
                        }

                        fetch(config.url.API_URL + '/project_homes/' + datas.project_home_id, requestOptions)
                            .then(res => res.json())
                            .then(data => {
                                let project_homes = data.data[0]
                                fetch(config.url.API_URL + '/residences/?projecthomeid=' + datas.project_home_id, requestOptions)
                                    .then(res => res.json())
                                    .then(async data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        let FromApi = await data.data.map((datas, key) => {
                                            return datas.house_no
                                        });

                                        this.setState({
                                            residences: FromApi
                                        });

                                        fetch(config.url.API_URL + '/service_categorys/?activestatus=1', requestOptions)
                                            .then(res => res.json())
                                            .then(data => {
                                                var FromApi = data.data.map(datas => {
                                                    return { value: datas.id, display: datas.name_th }
                                                });
                                                // store user details and jwt token in local storage to keep user logged in between page refreshes
                                                //alert(data.status);
                                                if (project_homes.central_flag == 1) {
                                                    fetch(config.url.API_URL + '/juristic_categorys/?activestatus=1', requestOptions)
                                                        .then(res => res.json())
                                                        .then(data => {

                                                            let FromApi2 = data.data.map(datas => {
                                                                return { value: datas.id, display: datas.name_th }
                                                            });

                                                            let FromApiAll = FromApi.concat(FromApi2)
                                                            this.setState({
                                                                home_number: datas.house_no,
                                                                phone_come: this.state.get_phone,
                                                                owner_first_name: dataFullName[0],
                                                                owner_last_name: dataFullName[dataFullName.length - 1],
                                                                owner_id: member_id,
                                                                residences_id: this.state.get_id,
                                                                phone_contact: tell,
                                                                project_name: datas.project_home_id,
                                                                pro_address: address,
                                                                project_id: datas.project_home_id,
                                                                delivery_date: (datas.delivery_date ? moment(datas.delivery_date).format('YYYY-MM-DD') : ""),
                                                                expire_date: (expired_insurance ? new Date(expired_insurance.format('YYYY-MM-DD')) : ''),
                                                                project_status: (datas.expired_insurance && (diffdate > 0 ? 'expire' : 'insurance')),
                                                                service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(FromApiAll)
                                                            })
                                                        });
                                                } else {
                                                    this.setState({
                                                        home_number: datas.house_no,
                                                        phone_come: this.state.get_phone,
                                                        owner_first_name: data[0],
                                                        owner_last_name: data[data.length - 1],
                                                        phone_contact: tell,
                                                        project_name: datas.project_home_id,
                                                        pro_address: address,
                                                        project_id: datas.project_home_id,
                                                        delivery_date: (datas.delivery_date ? moment(datas.delivery_date).format('YYYY-MM-DD') : ""),
                                                        expire_date: (expired_insurance ? new Date(expired_insurance.format('YYYY-MM-DD')) : ''),
                                                        project_status: (datas.expired_insurance && (diffdate > 0 ? 'expire' : 'insurance')),
                                                        service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(FromApi)

                                                    })
                                                }
                                            });
                                    });
                            });

                    }
             
        }

        const script = document.createElement("script");

        script.src = "/js/newform.js";
        script.async = true;
        document.body.appendChild(script);
    }

    handleSubmit(e) {

        //console.log(jwt);
        let list = [];

        if (this.state.IsMore) {
            for (var i = 1; i <= 10; i++) {
                if (this.state["detail" + i] != "") {
                    list.push({
                        service_type_id: this.state["service_type_id" + i].split(",")[0],
                        service_type_name: this.state["service_type_id" + i].split(",")[1],
                        detail: this.state["detail" + i],
                        subscriber: this.state["subscriber" + i],
                        operator: this.state["operator" + i],
                        serviceDate: this.state["serviceDate" + i],
                        successDate: this.state["successDate" + i],
                        editDate: this.state["editDate" + i],
                        note: this.state["note" + i],
                        serviceStatus: this.state["serviceStatus" + i] == "coordinate" ? "" : this.state["serviceStatus" + i],
                    })
                }
            }
        } else {
            
            list.push({
                // service_type_id: (this.state.server_type_id ? this.state.server_type_id : '5a627dab3fc2394c4f824e94'),
                service_type_id: (this.state.server_type_id ? this.state.server_type_id : ''),
                service_type_name: this.state.title,
                detail: this.state.detail,
                subscriber: "",
                operator: "",
                serviceDate: null,
                successDate: null,
                editDate: null,
                note: "",
                serviceStatus: "coordinate",
                img: []
            })

        }

        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                owner_first_name: this.state.owner_first_name,
                owner_last_name: this.state.owner_last_name,
                phone_come: this.state.phone_come,
                phone_contact: this.state.phone_contact,
                project_name: this.state.project_name,
                home_number: this.state.home_number,
                project_status: this.state.project_status,
                warranty: this.state.warranty,
                category: this.state.category,
                grouptype: this.state.grouptypeid,
                title: this.state.title,
                detail: this.state.detail,
                contact: this.state.contact,
                service_status: this.state.service_status,
                delivery_date: this.state.delivery_date,
                expired_insurance: this.state.expire_date,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id,
                member_id: this.state.owner_id,
                sla_start_date: new Date(moment(moment(this.state.sla_start_date).format('YYYY-MM-DD ') + moment(this.state.sla_start_date).format('H:m'))),
                sla_end_date: new Date(moment(moment(this.state.sla_end_date).format('YYYY-MM-DD ') + this.state.sla_end_time)),
                express: (this.state.express == "on" ? true : false),
                detail_list: list,
                residences_id: this.state.residences_id
            }),
        };

        //console.log(list)
        if (this.state.IsCallCenter) {
            fetch(config.url.API_URL + '/service_complaints', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.props.history.push('/my-case');
                    //history.push('/');
                });
        } else {
            fetch(config.url.API_URL + '/juristics', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.props.history.push('/my-case');
                    //history.push('/');
                });
        }

    }

    openModal(e) {
        e.preventDefault();
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.first_name == "") {
            alert("ไม่พบข้อมูลชื่อผู้ร้องเรียน กรุณาเลือกข้อมูลชื่อผู้ร้องเรียนก่อนบันทึกรายการ");
            return;
        }

        if (this.state.last_name == "") {
            alert("ไม่พบข้อมูลนามสกุลผู้ร้องเรียน กรุณาเลือกข้อมูลนามสกุลผู้ร้องเรียนก่อนบันทึกรายการ");
            return;
        }

        if (this.state.phone_come == "") {
            alert("ไม่พบข้อมูลเบอร์โทรเข้า กรุณาเลือกข้อมูลเบอร์โทรเข้าก่อนบันทึกรายการ");
            return;
        }

        if (this.state.phone_contact == "") {
            alert("ไม่พบข้อมูลเบอร์โทรติดต่อ กรุณาเลือกข้อมูลเบอร์โทรติดต่อก่อนบันทึกรายการ");
            return;
        }

        if (this.state.project_name == "") {
            alert("ไม่พบข้อมูลโครงการ กรุณาเลือกข้อมูลโครงการก่อนบันทึกรายการ");
            return;
        }

        if (this.state.category == "") {
            alert("ไม่พบข้อมูลหมวดเรื่อง กรุณาเลือกข้อมูลหมวดเรื่องก่อนบันทึกรายการ");
            return;
        }

        if (this.state.grouptypeid == "") {
            alert("ไม่พบข้อมูลกลุ่มหัวข้อ กรุณาเลือกข้อมูลกลุ่มหัวข้อก่อนบันทึกรายการ");
            return;
        }

        if (this.state.title == "") {
            alert("ไม่พบข้อมูลเรื่องย่อย กรุณาเลือกข้อมูลเรื่องย่อยก่อนบันทึกรายการ");
            return;
        }

        /* ตรวจสอบบ้านเลขที่มีไหม
        fetch(config.url.API_URL+'/residences/?houseno='+(this.state.home_number?this.state.home_number:'')
            , requestOptions)
            .then(res => res.json())
            .then(data => {
                if(Array.isArray(data.data) && data.data.length == 0){
                    alert("บ้านเลขที่นี้ไม่มีในระบบ กรุณาตรวจสอบอีกครั้ง");
                    return;
                }else{
                    this.setState({modalIsOpen: true});
                }
            });
            */

        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    showOption(option, val, display) {
        if (option == val) {
            return <option value={val} selected>{display}</option>
        } else {
            return <option value={val}>{display}</option>
        }
    }
    //5a627dab3fc2394c4f824e94 = 0
    cancelForm() {
        this.setState({
            first_name: '',
            last_name: '',
            owner_first_name: '',
            owner_last_name: '',
            phone_come: '',
            phone_contact: '',
            project_name: '5a627dab3fc2394c4f824e94',
            home_number: '',
            project_status: '',
            warranty: '',
            category: '',
            title: '',
            detail: '',
            contact: 'cc',
            service_status: 'progress',
        });
        document.getElementById("new-form").reset();
        this.setState({ modalIsOpenCancel: false });
    }

    closeModalCancel() {
        this.setState({ modalIsOpenCancel: false });
    }

    openModalCancel() {
        this.setState({ modalIsOpenCancel: true });
    }

    changeDate_serviceDate1 = date => {
        this.setState({
            serviceDate1: date
        });
    }

    changeDate_serviceDate2 = date => {
        this.setState({
            serviceDate2: date
        });
    }

    changeDate_serviceDate3 = date => {
        this.setState({
            serviceDate3: date
        });
    }

    changeDate_serviceDate4 = date => {
        this.setState({
            serviceDate4: date
        });
    }

    changeDate_serviceDate5 = date => {
        this.setState({
            serviceDate5: date
        });
    }

    changeDate_serviceDate6 = date => {
        this.setState({
            serviceDate6: date
        });
    }

    changeDate_serviceDate7 = date => {
        this.setState({
            serviceDate7: date
        });
    }

    changeDate_serviceDate8 = date => {
        this.setState({
            serviceDate8: date
        });
    }

    changeDate_serviceDate9 = date => {
        this.setState({
            serviceDate9: date
        });
    }

    changeDate_serviceDate10 = date => {
        this.setState({
            serviceDate10: date
        });
    }

    changeDate_successDate1 = date => {
        this.setState({
            successDate1: date
        });
    }

    changeDate_successDate2 = date => {
        this.setState({
            successDate2: date
        });
    }

    changeDate_successDate3 = date => {
        this.setState({
            successDate3: date
        });
    }

    changeDate_successDate4 = date => {
        this.setState({
            successDate4: date
        });
    }

    changeDate_successDate5 = date => {
        this.setState({
            successDate5: date
        });
    }

    changeDate_successDate5 = date => {
        this.setState({
            successDate5: date
        });
    }

    changeDate_successDate6 = date => {
        this.setState({
            successDate6: date
        });
    }

    changeDate_successDate7 = date => {
        this.setState({
            successDate7: date
        });
    }

    changeDate_successDate8 = date => {
        this.setState({
            successDate8: date
        });
    }

    changeDate_successDate9 = date => {
        this.setState({
            successDate9: date
        });
    }

    changeDate_successDate10 = date => {
        this.setState({
            successDate10: date
        });
    }

    changeDate_editDate1 = date => {
        this.setState({
            editDate1: date
        });
    }

    changeDate_editDate2 = date => {
        this.setState({
            editDate2: date
        });
    }

    changeDate_editDate3 = date => {
        this.setState({
            editDate3: date
        });
    }

    changeDate_editDate4 = date => {
        this.setState({
            editDate4: date
        });
    }

    changeDate_editDate5 = date => {
        this.setState({
            editDate5: date
        });
    }

    changeDate_editDate6 = date => {
        this.setState({
            editDate6: date
        });
    }

    changeDate_editDate7 = date => {
        this.setState({
            editDate7: date
        });
    }

    changeDate_editDate8 = date => {
        this.setState({
            editDate8: date
        });
    }

    changeDate_editDate9 = date => {
        this.setState({
            editDate9: date
        });
    }

    changeDate_editDate10 = date => {
        this.setState({
            editDate10: date
        });
    }

    onTagsChange = async (event, values) => {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (values != null) {
                this.setState({
                    home_number: values
                })
    
                const ResidenceData = await(await fetch(config.url.API_URL + `/residences/?projecthomeid=${this.state.project_name}&houseno=${values}`, requestOptions)).json()

                if(Array.isArray(ResidenceData.data) && ResidenceData.data.length > 0) {

                    const residence = ResidenceData.data[0]

                    if(Array.isArray(residence) && residence.customer.length > 0) {
                        const memberId = residence.customer[0].customer_id
                        const membername = residence.customer[0].customer_name
                        const dataFullName = membername.split(" ");

                        if (residence.expired_insurance) {
                            var expired_insurance = moment(residence.expired_insurance);
                        }

                        this.setState({
                            owner_first_name: dataFullName[0],
                            owner_last_name: dataFullName[dataFullName.length - 1],
                            owner_id: memberId,
                            residences_id: residence.id,
                            delivery_date: (residence.delivery_date ? moment(residence.delivery_date).format('YYYY-MM-DD') : ""),
                            expire_date: (expired_insurance ? new Date(expired_insurance.format('YYYY-MM-DD')) : ''),
                        })
                    }else{
                        // no customer in residence
                        console.log(`residence data`)
                        console.log(residence)
                        this.setState({
                            residences_id: residence.id,
                            delivery_date: (residence.delivery_date ? moment(residence.delivery_date).format('YYYY-MM-DD') : ""),
                            expire_date: (residence ? new Date(moment(residence.expired_insurance).format('YYYY-MM-DD')) : ''),
                        })
                    }
                    

                }
            }
    
            //     fetch(config.url.API_URL + `/residences/?projecthomeid=${this.state.project_name}&houseno=${values}`, requestOptions)
            //         .then(res => res.json())
            //         .then(async data => {
            //             if (data.data.length > 0) {
            //                 var residencesData = data.data[0]
            //                 if (residencesData.customer.length > 0) {
            //                     var memberId = residencesData.customer[0].customer_id
            //                     var membername = residencesData.customer[0].customer_name
            //                     var dataFullName = membername.split(" ");
    
    
            //                     if (residencesData.expired_insurance) {
            //                         var expired_insurance = moment(residencesData.expired_insurance);
            //                     }
            //                     this.setState({
            //                         owner_first_name: dataFullName[0],
            //                         owner_last_name: dataFullName[dataFullName.length - 1],
            //                         owner_id: memberId,
            //                         residences_id: residencesData.id,
            //                         delivery_date: (residencesData.delivery_date ? moment(residencesData.delivery_date).format('YYYY-MM-DD') : ""),
            //                         expire_date: (expired_insurance ? new Date(expired_insurance.format('YYYY-MM-DD')) : ''),
            //                     })
            //                 } else {
            //                     this.setState({
            //                         residences_id: residencesData.id,
            //                         delivery_date: (residencesData.delivery_date ? moment(residencesData.delivery_date).format('YYYY-MM-DD') : ""),
            //                         expire_date: (expired_insurance ? new Date(expired_insurance.format('YYYY-MM-DD')) : ''),
            //                     })
            //                 }
            //             }
            //         })
            // }
        } catch (error) {
            console.log(`error durring fetch house data in autocomplete`)
            console.log(error)
        }
        
    }
    render() {
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">เปิดใบงาน</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">เปิดใบงาน</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                <HeaderTab />
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                {/* .card-header */}
                                <div>
                                    {this.state.matches && (<div className="card-body">
                                        <h1><img src={"../dist/img/icon/ic_newform.png"} width="auto" height={50} /> New Form</h1>
                                        <div className="row">
                                            <div className="col-12">
                                                <form method="post" onSubmit={this.openModal} id="new-form">
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <div className="row pr-3">
                                                                <div className="col-12 text-right">
                                                                    <h4><img src={"../dist/img/icon/ic_tab_profile.png"} width="auto" height={30} /> ข้อมูลส่วนตัว</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-10 pl-3" style={{ borderLeft: '1px solid #162540' }}>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">เจ้าบ้าน<span className="text-danger"></span></span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <input type="text" className="form-custom " name="owner_first_name" placeholder="ชื่อ" disabled={true} defaultValue={this.state.owner_first_name} onChange={this.change} />
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <input type="text" className="form-custom " name="owner_last_name" placeholder="นามสกุล" disabled={true} defaultValue={this.state.owner_last_name} onChange={this.change} />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">ผู้แจ้ง<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <input type="text" className="form-custom " name="first_name" placeholder="ชื่อ" defaultValue={this.state.first_name} onChange={this.change} />
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <input type="text" className="form-custom " name="last_name" placeholder="นามสกุล" defaultValue={this.state.last_name} onChange={this.change} />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">เบอร์โทรเข้า<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <span className="label"><input type="text" className="form-custom " name="phone_come" defaultValue={this.state.phone_come} onChange={this.change} /></span>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">เบอร์ติดต่อ<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <input type="text" className="form-custom " name="phone_contact" onChange={this.change} defaultValue={this.state.phone_contact} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <div className="row pr-3">
                                                                <div className="col-12 text-right">
                                                                    <h4><img src={"../dist/img/icon/ic_report_01.png"} width="auto" height={30} /> ข้อมูลโครงการ</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-10 pl-3" style={{ borderLeft: '1px solid #162540' }}>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">โครงการ<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-4">
                                                                    <select className="form-custom" name="project_name" onChange={this.change}>
                                                                        {this.state.project_home.map((datas) => this.showOption(this.state.project_id, datas.value, datas.display))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">สถานะ</span>
                                                                </div>
                                                                <div className="col-4">
                                                                    <select className="form-custom" name="project_status" onChange={this.change}>
                                                                        <option value="">เลือกสถานะ</option>
                                                                        <option value="book">จอง</option>
                                                                        <option value="sign">ทำสัญญา</option>
                                                                        <option value="transfer">โอน(ยังไม่รับมอบบ้าน)</option>
                                                                        <option value="insurance" selected={(this.state.project_status == 'insurance' && 'selected')}>ในประกัน(คิดจากเวลาประกัน)</option>
                                                                        <option value="expire" selected={(this.state.project_status == 'expire' && 'selected')}>หมดประกัน(คิดจากเวลาประกัน)</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">บ้านเลขที่</span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    {/* <Autocomplete
                                                                    name="home_number"
                                                                    value={this.state.home_number}
                                                                    options={this.state.residences}
                                                                    renderInput={(params) => <TextField {...params} label="" variant="outlined"
                                                                        size="small" />}
                                                                    onChange={this.onTagsChange} /> */}
                                                                    <Autocomplete
                                                                        name="home_number"
                                                                        value={this.state.home_number}
                                                                        options={this.state.residences}
                                                                        autoHighlight
                                                                        //getOptionLabel={(option) => option.display}
                                                                        renderInput={(params) => <TextField
                                                                            {...params}
                                                                            label=""
                                                                            variant="outlined"
                                                                            inputProps={{
                                                                                ...params.inputProps,
                                                                                style: { fontSize: 20, fontFamily: "db_heaventmed_cond" }
                                                                            }}
                                                                            size="small"
                                                                        />}
                                                                        onChange={this.onTagsChange} />
                                                                </div>
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">หมดรับประกัน</span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.expire_date} id="expire_date" name="expire_date" className="form-custom" onChange={this.changeExpireDate} dateFormat="dd/MM/yyyy" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <div className="row pr-3">
                                                                <div className="col-12 text-right">
                                                                    <h4><img src={"../dist/img/icon/ic_project.png"} width="auto" height={30} /> เรื่องที่ติดต่อ</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-10 pl-3" style={{ borderLeft: '1px solid #162540' }}>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">หมวดเรื่อง<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="cus-col-label-2">
                                                                    <select className="form-custom" name="category" onChange={this.change}>
                                                                        {this.state.service_category.map((datas, key) =>
                                                                            <option key={key} value={datas.value} selected={(this.state.category == datas.value && 'selected')}>{datas.display}</option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                                <div className="col-1">
                                                                    <span className="label">กลุ่มหัวข้อ<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-6">
                                                                    <select className="form-custom" name="grouptypeid" onChange={this.change}>
                                                                        {this.state.group_type.map((datas, key) =>
                                                                            <option key={key} value={datas.value}>{datas.display}</option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">เรื่องย่อย<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-6">
                                                                    <select className="form-custom" name="title" onChange={this.change}>
                                                                        {this.state.service_type.map((datas, key) =>
                                                                            <option key={key} value={datas.value}>{datas.display}</option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">ผู้เกี่ยวข้อง</span>
                                                                </div>
                                                                <div className="col-9">to :
                                                            {this.state.emailto.map((datas, key) =>
                                                                    (datas.email === "" ? '' : (<span key={key} >{datas.display + " <" + datas.email + ">, "}</span>))
                                                                )}
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label"></span>
                                                                </div>
                                                                <div className="col-9">cc :
                                                            {this.state.emailcc.map((datas, key) =>
                                                                    (datas.email === "" ? '' : (<span key={key} >{datas.display + " <" + datas.email + ">, "}</span>))
                                                                )}
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">SLA <span className="text-danger">{(this.state.sla_val && (this.state.sla_val > 24 ? (this.state.sla_val / 24) + ' วัน' : this.state.sla_val + ' ชั่วโมง'))}</span></span>
                                                                </div>
                                                                <div className="col-1" style={{ maxWidth: '63px' }}>เริ่มต้น : </div>
                                                                <div className="col-2">
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" readOnly selected={this.state.sla_start_date} id="sla_start_date" name="sla_start_date" className="form-custom" onChange={this.changeSLAStartDate} dateFormat="dd/MM/yyyy" />
                                                                </div>
                                                                <div className="col-2">
                                                                    <input type="time" className="form-custom" readOnly defaultValue={this.state.sla_start_time} />
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label"></span>
                                                                </div>
                                                                <div className="col-1" style={{ maxWidth: '63px' }}>สิ้นสุด : </div>
                                                                <div className="col-2">
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.sla_end_date} id="sla_end_date" name="sla_end_date" className="form-custom" onChange={this.changeSLAEndDate} dateFormat="dd/MM/yyyy" />
                                                                </div>
                                                                <div className="col-2">
                                                                    <input type="time" className="form-custom" name="sla_end_time" onChange={this.change} defaultValue={this.state.sla_end_time} />
                                                                </div>
                                                            </div>


                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">รายละเอียด</span>
                                                                </div>
                                                                <div className="col-4">
                                                                    <textarea className="form-custom" rows={3} defaultValue={""} name="detail" onChange={this.change} />
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3" id="detail_list" style={{ display: "none" }}>
                                                                <div className="col-12 table-responsive">
                                                                    <table className="table table-list10">
                                                                        <thead className="thead-blue">
                                                                            <tr>
                                                                                <th width="30px">No</th>
                                                                                <th>เรื่องย่อย</th>
                                                                                <th>รายการซ่อม</th>
                                                                                <th width="10%">ผู้เซ็นต์รับ</th>
                                                                                <th width="10%">ผู้ดำเนินการ</th>
                                                                                <th width="9%">วันที่ช่างเข้า</th>
                                                                                <th width="9%">วันที่แล้วเสร็จ</th>
                                                                                <th width="9%">วันที่แก้ไขเพิ่มเติม</th>
                                                                                <th>หมายเหตุ</th>
                                                                                <th width="11%">สถานะการซ่อม</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {this.state.fromList.map((data, key) => (
                                                                                <tr key={key} >
                                                                                    <td>{data.row}</td>
                                                                                    <td>
                                                                                        <select className="form-custom" name={data.col9} onChange={this.change}>
                                                                                            {this.state.service_type_all.map((datas, key) =>
                                                                                                <option key={key} value={datas.value}>{datas.display}</option>)
                                                                                            }
                                                                                        </select>
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col1}
                                                                                            onChange={this.change} defaultValue={this.state[data.col1]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col2}
                                                                                            defaultValue={this.state[data.col2]} onChange={this.change} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col3}
                                                                                            defaultValue={this.state[data.col3]} onChange={this.change} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col4]}
                                                                                            name={data.col4} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col4]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col5]}
                                                                                            name={data.col5} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col5]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col6]}
                                                                                            name={data.col6} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col6]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col7}
                                                                                            defaultValue={this.state[data.col7]} onChange={this.change} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <select className="form-custom" name={data.col8} onChange={this.change}>
                                                                                            <option value="">เลือกสถานะการซ่อม</option>
                                                                                            <option selected={this.state[data.col8] == "progress" && "selected"} value="progress">กำลังดำเนินการ</option>
                                                                                            <option selected={this.state[data.col8] == "finish" && "selected"} value="finish">จบงาน</option>
                                                                                            <option selected={this.state[data.col8] == "cancel" && "selected"} value="cancel">ยกเลิก</option>
                                                                                        </select>
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">เร่งด่วน</span>
                                                                </div>
                                                                <div className="col-4">
                                                                    <input type="checkbox" name="express" onChange={this.change} />
                                                                </div>
                                                            </div>

                                                            <div className="row mt-3">
                                                                <div className="cus-col-label-1">
                                                                    <span className="label">การบันทึก</span>
                                                                </div>
                                                                <div className="col-3">
                                                                    <select className="form-custom" name="service_status" onChange={this.change}>
                                                                        <option value="progress">Call Center รับเรื่อง</option>
                                                                        <option value="doing">กำลังดำเนินการ</option>
                                                                        <option value="cancel">ยกเลิก</option>
                                                                        <option value="close" className="text-success">จบงาน</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-5 mb-3">
                                                        <div className="col-12 text-center">
                                                            <input type="submit" className="btn-save" name="Save" value="บันทึก" />
                                                            <input type="button" className="btn-cancel ml-3" name="Cancel" onClick={this.openModalCancel} defaultValue="ยกเลิก" />
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>)}
                                    {!this.state.matches && (<div className="card-body">
                                        <h3><img src={"../dist/img/icon/ic_newform.png"} width="auto" height={20} /> New Form</h3><br />
                                        <div className="row">
                                            <div className="col-12">
                                                <form method="post" onSubmit={this.openModal} id="new-form">
                                                    <div className="row">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <h4><img src={"../dist/img/icon/ic_tab_profile.png"} width="auto" height={30} /> ข้อมูลส่วนตัว</h4>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-2">
                                                                    <span className="label">เจ้าบ้าน<span className="text-danger"></span></span>
                                                                </div>
                                                                <div className="col-5">
                                                                    <input type="text" className="form-custom" name="owner_first_name" placeholder="ชื่อ" disabled={true} defaultValue={this.state.owner_first_name} onChange={this.change} />
                                                                </div>
                                                                <div className="col-5">
                                                                    <input type="text" className="form-custom" name="owner_last_name" placeholder="นามสกุล" disabled={true} defaultValue={this.state.owner_last_name} onChange={this.change} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-2">
                                                                    <span className="label">ผู้แจ้ง<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-5">
                                                                    <input type="text" className="form-custom " name="first_name" placeholder="ชื่อ" defaultValue={this.state.first_name} onChange={this.change} />
                                                                </div>
                                                                <div className="col-5">
                                                                    <input type="text" className="form-custom " name="last_name" placeholder="นามสกุล" defaultValue={this.state.last_name} onChange={this.change} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-4">
                                                                    <span className="label">เบอร์โทรเข้า<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-8">
                                                                    <span className="label"><input type="text" className="form-custom " name="phone_come" defaultValue={this.state.phone_come} onChange={this.change} /></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-4">
                                                                    <span className="label">เบอร์ติดต่อ<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-8">
                                                                    <input type="text" className="form-custom " name="phone_contact" onChange={this.change} defaultValue={this.state.phone_contact} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <h4><img src={"../dist/img/icon/ic_report_01.png"} width="auto" height={30} /> ข้อมูลโครงการ</h4>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-3">
                                                                    <span className="label">โครงการ<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-9">
                                                                    <select className="form-custom" name="project_name" onChange={this.change}>
                                                                        {this.state.project_home.map((datas) => this.showOption(this.state.project_id, datas.value, datas.display))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-4">
                                                                    <span className="label">สถานะ</span>
                                                                </div>
                                                                <div className="col-8">
                                                                    <select className="form-custom" name="project_status" onChange={this.change}>
                                                                        <option value="">เลือกสถานะ</option>
                                                                        <option value="book">จอง</option>
                                                                        <option value="sign">ทำสัญญา</option>
                                                                        <option value="transfer">โอน(ยังไม่รับมอบบ้าน)</option>
                                                                        <option value="insurance" selected={(this.state.project_status == 'insurance' && 'selected')}>ในประกัน(คิดจากเวลาประกัน)</option>
                                                                        <option value="expire" selected={(this.state.project_status == 'expire' && 'selected')}>หมดประกัน(คิดจากเวลาประกัน)</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-5">
                                                                    <span className="label">บ้านเลขที่</span>
                                                                </div>
                                                                <div className="col-7">
                                                                    <div style={{ width: "150px" }}>
                                                                        <Autocomplete
                                                                            name="home_number"
                                                                            value={this.state.home_number}
                                                                            options={this.state.residences}
                                                                            autoHighlight
                                                                            renderInput={(params) => <TextField
                                                                                {...params}
                                                                                label=""
                                                                                variant="outlined"
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    style: { fontSize: 20, fontFamily: "db_heaventmed_cond" }
                                                                                }}
                                                                                size="small"
                                                                            />}
                                                                            onChange={this.onTagsChange} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-4">
                                                                    <span className="label">หมดรับประกัน</span>
                                                                </div>
                                                                <div className="col-8">
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.expire_date} id="expire_date" name="expire_date" className="form-custom" onChange={this.changeExpireDate} dateFormat="dd/MM/yyyy" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="row">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <h4><img src={"../dist/img/icon/ic_project.png"} width="auto" height={30} />เรื่องที่ติดต่อ</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-5">
                                                                    <span className="label">หมวดเรื่อง<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-7">
                                                                    <div style={{ width: "150px" }}>
                                                                        <select className="form-custom" name="category" onChange={this.change}>
                                                                            {this.state.service_category.map((datas, key) =>
                                                                                <option key={key} value={datas.value} selected={(this.state.category == datas.value && 'selected')}>{datas.display}</option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-5">
                                                                    <span className="label">กลุ่มหัวข้อ<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-7">
                                                                    <div style={{ width: "150px" }}>
                                                                        <select className="form-custom" name="grouptypeid" onChange={this.change}>
                                                                            {this.state.group_type.map((datas, key) =>
                                                                                <option key={key} value={datas.value}>{datas.display}</option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-5">
                                                                    <span className="label">เรื่องย่อย<span className="text-danger">*</span></span>
                                                                </div>
                                                                <div className="col-7">
                                                                    <div style={{ width: "150px" }}>
                                                                        <select className="form-custom" name="title" onChange={this.change}>
                                                                            {this.state.service_type.map((datas, key) =>
                                                                                <option key={key} value={datas.value}>{datas.display}</option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <span className="label">ผู้เกี่ยวข้อง</span>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-3">
                                                                    <span className="label"></span>
                                                                </div>
                                                                <div className="col-9">to :
                                                            {this.state.emailto.map((datas, key) =>
                                                                    (datas.email === "" ? '' : (<span key={key} >{datas.display + " <" + datas.email + ">, "}</span>))
                                                                )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-3">
                                                                    <span className="label"></span>
                                                                </div>
                                                                <div className="col-9">cc :
                                                            {this.state.emailcc.map((datas, key) =>
                                                                    (datas.email === "" ? '' : (<span key={key} >{datas.display + " <" + datas.email + ">, "}</span>))
                                                                )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-5">
                                                                <span className="label">SLA <span className="text-danger">{(this.state.sla_val && (this.state.sla_val > 24 ? (this.state.sla_val / 24) + ' วัน' : this.state.sla_val + ' ชั่วโมง'))}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-2">
                                                                    <span className="label">เริ่มต้น</span>
                                                                </div>
                                                                <div className="col-5">
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" readOnly selected={this.state.sla_start_date} id="sla_start_date" name="sla_start_date" className="form-custom" onChange={this.changeSLAStartDate} dateFormat="dd/MM/yyyy" />
                                                                </div>
                                                                <div className="col-5">
                                                                    <input type="time" className="form-custom" readOnly defaultValue={this.state.sla_start_time} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-2">
                                                                    <span className="label">สิ้นสุด</span>
                                                                </div>
                                                                <div className="col-5">
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.sla_end_date} id="sla_end_date" name="sla_end_date" className="form-custom" onChange={this.changeSLAEndDate} dateFormat="dd/MM/yyyy" />
                                                                </div>
                                                                <div className="col-5">
                                                                    <input type="time" className="form-custom" name="sla_end_time" onChange={this.change} defaultValue={this.state.sla_end_time} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-3">
                                                                    <span className="label">รายละเอียด</span>
                                                                </div>
                                                                <div className="col-9">
                                                                    <textarea className="form-custom" rows={3} defaultValue={""} name="detail" onChange={this.change} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="row mb-3" id="detail_list" style={{ display: "none" }}>
                                                                <div className="col-12 table-responsive">
                                                                    <table className="table" style={{width: "1500px"}}>
                                                                        <thead className="thead-blue">
                                                                            <tr>
                                                                                <th width="30px">No</th>
                                                                                <th width="13%">เรื่องย่อย</th>
                                                                                <th>รายการซ่อม</th>
                                                                                <th width="10%">ผู้เซ็นต์รับ</th>
                                                                                <th width="10%">ผู้ดำเนินการ</th>
                                                                                <th width="10%">วันที่ช่างเข้า</th>
                                                                                <th width="10%">วันที่แล้วเสร็จ</th>
                                                                                <th width="10%">วันที่แก้ไขเพิ่มเติม</th>
                                                                                <th>หมายเหตุ</th>
                                                                                <th width="13%">สถานะการซ่อม</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {this.state.fromList.map((data, key) => (
                                                                                <tr key={key} >
                                                                                    <td>{data.row}</td>
                                                                                    <td>
                                                                                        <select className="form-custom" name={data.col9} onChange={this.change}>
                                                                                            {this.state.service_type_all.map((datas, key) =>
                                                                                                <option key={key} value={datas.value}>{datas.display}</option>)
                                                                                            }
                                                                                        </select>
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col1}
                                                                                            onChange={this.change} defaultValue={this.state[data.col1]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col2}
                                                                                            defaultValue={this.state[data.col2]} onChange={this.change} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col3}
                                                                                            defaultValue={this.state[data.col3]} onChange={this.change} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col4]}
                                                                                            name={data.col4} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col4]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col5]}
                                                                                            name={data.col5} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col5]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-custom" selected={this.state[data.col6]}
                                                                                            name={data.col6} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col6]} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" className="form-custom" name={data.col7}
                                                                                            defaultValue={this.state[data.col7]} onChange={this.change} />
                                                                                    </td>
                                                                                    <td>
                                                                                        <select className="form-custom" name={data.col8} onChange={this.change}>
                                                                                            <option value="">เลือกสถานะการซ่อม</option>
                                                                                            <option selected={this.state[data.col8] == "progress" && "selected"} value="progress">กำลังดำเนินการ</option>
                                                                                            <option selected={this.state[data.col8] == "finish" && "selected"} value="finish">จบงาน</option>
                                                                                            <option selected={this.state[data.col8] == "cancel" && "selected"} value="cancel">ยกเลิก</option>
                                                                                        </select>
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mb-3">
                                                                <div className="col-8">
                                                                    <span className="label">เร่งด่วน</span>
                                                                </div>
                                                                <div className="col-4">
                                                                    <input type="checkbox" name="express" onChange={this.change} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mt-3">
                                                                <div className="col-4">
                                                                    <span className="label">การบันทึก</span>
                                                                </div>
                                                                <div className="col-8">
                                                                    <select className="form-custom" name="service_status" onChange={this.change}>
                                                                        <option value="progress">Call Center รับเรื่อง</option>
                                                                        <option value="doing">กำลังดำเนินการ</option>
                                                                        <option value="cancel">ยกเลิก</option>
                                                                        <option value="close" className="text-success">จบงาน</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row mt-5 mb-3">
                                                                <div className="col-12">
                                                                    <input type="submit" className="btn btn-outline-primary" name="Save" value="บันทึก" />&nbsp;&nbsp;
                                                                    <input type="button" className="btn btn-outline-dark" name="Cancel" onClick={this.openModalCancel} defaultValue="ยกเลิก" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>)}
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                    <Modal show={this.state.modalIsOpen} onHide={this.closeModal}>
                        <ModalHeader>
                            <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            <h2>คุณต้องการบันทึกรายการนี้ใช่หรือไม่</h2>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" onClick={this.closeModal}>ยกเลิก</button>
                            <button className="btn btn-info" onClick={this.handleSubmit}>บันทึก</button>
                        </ModalFooter>
                    </Modal>

                    <Modal show={this.state.modalIsOpenCancel} onHide={this.closeModalCancel}>
                        <ModalHeader>
                            <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            <h3>คุณต้องการยกเลิกรายการนี้ใช่หรือไม่</h3>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" onClick={this.closeModalCancel}>ยกเลิก</button>
                            <button className="btn btn-info" onClick={this.cancelForm}>ตกลง</button>
                        </ModalFooter>
                    </Modal>

                </section>
            </div>
        );
    }
}

export default withRouter(NewForm);